module.exports = __webpack_public_path__ + "static/media/CAR-3.89df954c.jpg";